import type { Ampel } from "@/lib/api"

const STYLES: Record<Ampel, string> = {
  gruen: "bg-green-100 text-green-800",
  orange: "bg-orange-100 text-orange-800",
  rot: "bg-red-100 text-red-800",
}

const LABELS: Record<Ampel, string> = {
  gruen: "grün",
  orange: "orange",
  rot: "rot",
}

/** Generische Ampel-Anzeige (ARCHITEKTUR.md §5) — für Prüfungen UND Wartungen. */
export function AmpelBadge({ ampel }: { ampel: Ampel }) {
  return (
    <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${STYLES[ampel]}`}>
      {LABELS[ampel]}
    </span>
  )
}
